import React from "react";

const SalonXp = () => {
  return (
    <div className="salonXpContainer">
      <h5>The SCENT Experience</h5>
      <p>
        At SCENT , we believe in offering an unparalleled salon experience that
        leaves you feeling pampered and rejuvenated. Here’s what you can expect
        when you visit us for your ombre gel nail polish treatment:
      </p>
      <ul>
        <li>
          <h6>Professional Nail Technicians</h6>Our team of professional nail
          technicians is highly trained and experienced in the <a href="https://scentlifestyle.com/gel-nail-art">latest nail art
          techniques</a>, including <a href="https://scentlifestyle.com/chrome-gel-nail-polish">ombre gel polish</a>. They are dedicated to
          delivering precise and flawless results, ensuring your nails look
          stunning every time.
        </li>
        <li>
          <h6>High-Quality Products</h6>We use only the{" "}
          <a href="https://scentlifestyle.com/chrome-gel-nail-polish">best quality gel polishes</a> and nail products from
          reputable brands to ensure the safety and health of your nails. Our
          products are free from harmful chemicals, providing a safe and
          comfortable experience for our clients.
        </li>
        <li>
          <h6>Customized Consultations</h6>
          We understand that every client is unique, and so are their
          preferences. During your visit, our nail technicians will consult with
          you to understand your desired look and recommend the best color
          combinations and designs to achieve it.
        </li>
        <li>
          <h6>Hygienic Environment</h6>
          Your safety and well-being are our top priorities. We maintain the
          highest standards of hygiene and cleanliness at{" "}
          <a href="https://scentlifestyle.com/">SCENT</a> . All tools and
          equipment are sterilized before each use, and our salon environment is
          kept clean and sanitized at all times.
        </li>
      </ul>
    </div>
  );
};

export default SalonXp;
